import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-danger */

import { useCallback, useState, useEffect } from 'react';
import { styled } from '@classify/react-core-components/styles';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@classify/react-core-components/Typography';
import { LinkWrapper } from '../../../links';
const PREFIX = 'Faq';
const classes = {
  answer: `${PREFIX}-answer`,
  videoContainer: `${PREFIX}-videoContainer`,
  iframeContainer: `${PREFIX}-iframeContainer`,
  faqContainer: `${PREFIX}-faqContainer`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({
  theme: {
    typography,
    spacing
  }
}) => ({
  [`& .${classes.answer}`]: {
    '& a': {
      fontWeight: typography.fontWeightBold
    },
    '& li': {
      ...typography.body2
    }
  },
  [`& .${classes.videoContainer}`]: {
    maxWidth: 320
  },
  [`& .${classes.iframeContainer}`]: {
    marginTop: spacing(2),
    position: 'relative',
    aspectRatio: '16/9',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  },
  [`& .${classes.faqContainer}`]: {
    scrollMarginTop: '60px'
  }
}));

/* istanbul ignore next */
const getElementIdByFaqId = faqId => `faq_${faqId}`;
/* istanbul ignore next */
const getElementByFaqId = faqId => document.getElementById(getElementIdByFaqId(faqId));
/* istanbul ignore next */
const wait = ms => new Promise(r => {
  setTimeout(r, ms);
});
function Faq(t0) {
  const $ = _c(24);
  const {
    children,
    ariaLabel: t1
  } = t0;
  const ariaLabel = t1 === undefined ? "Show more information" : t1;
  const [expandedPanelId, setExpandedPanelId] = useState(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = panelId => (e, expanded) => {
      setExpandedPanelId(expanded ? panelId : null);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const getOnPanelChangeHandler = t2;
  let t3;
  if ($[1] !== expandedPanelId) {
    t3 = id => {
      if (expandedPanelId === null && document.location.hash === `#${getElementIdByFaqId(id)}`) {
        return true;
      }
      return expandedPanelId === id;
    };
    $[1] = expandedPanelId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const shouldOpenEntry = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = async faqId => {
      const faqElement = getElementByFaqId(faqId);
      if (faqElement) {
        setExpandedPanelId(faqId);
        await wait(150);
        faqElement.scrollIntoView({
          behavior: "smooth"
        });
        await wait(1000);
        faqElement.firstChild.focus();
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const scrollToOpenFaqItem = t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const handlePageLoad = async () => {
        await wait(500);
        const faqId_0 = document.location.hash.replace("#", "");
        scrollToOpenFaqItem(faqId_0);
      };
      handlePageLoad();
    };
    t6 = [];
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const handleFaqLink = async event => {
        const {
          target
        } = event;
        if (!target?.href) {
          return;
        }
        const targetUrl = new URL(target.href);
        const faqId_1 = targetUrl.hash.replace("#", "");
        if (targetUrl.pathname === document.location.pathname) {
          event.preventDefault();
          window.history.pushState({}, "", targetUrl);
          scrollToOpenFaqItem(faqId_1);
        }
      };
      document.body.addEventListener("click", handleFaqLink);
      return () => {
        document.body.removeEventListener("click", handleFaqLink);
      };
    };
    t8 = [];
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  useEffect(t7, t8);
  let t9;
  if ($[8] !== children) {
    t9 = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: children.map(_temp)
    });
    $[8] = children;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <script type="application/ld+json">{t9}</script>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== ariaLabel || $[13] !== children || $[14] !== expandedPanelId || $[15] !== shouldOpenEntry) {
    let t12;
    if ($[17] !== ariaLabel || $[18] !== expandedPanelId || $[19] !== shouldOpenEntry) {
      t12 = faqItem_0 => <Accordion key={faqItem_0.id} id={getElementIdByFaqId(faqItem_0.id)} expanded={shouldOpenEntry(faqItem_0.id)} onChange={getOnPanelChangeHandler(faqItem_0.id)} className={classes.faqContainer}><AccordionSummary aria-controls={`content-${faqItem_0.id}`} expandIcon={<ExpandMoreIcon aria-label={ariaLabel} />}><Typography variant="body">{faqItem_0.question}</Typography></AccordionSummary><AccordionDetails tabIndex={0}><LinkWrapper><Typography variant="bodySmall" component="p" className={classes.answer}><span dangerouslySetInnerHTML={{
                __html: faqItem_0.answer
              }} />{faqItem_0.link && <>{" "}<a href={faqItem_0.link.href} target="_blank" rel="noopener noreferrer" tabIndex={expandedPanelId === faqItem_0.id ? 0 : -1}>{faqItem_0.link.label}</a></>}{faqItem_0.answerEnd}</Typography></LinkWrapper>{faqItem_0.videoLink && <div className={classes.videoContainer}><div className={classes.iframeContainer}><iframe title={faqItem_0.question} src={faqItem_0.videoLink} frameBorder="0" allowFullScreen={true} /></div></div>}</AccordionDetails></Accordion>;
      $[17] = ariaLabel;
      $[18] = expandedPanelId;
      $[19] = shouldOpenEntry;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    t11 = children.map(t12);
    $[12] = ariaLabel;
    $[13] = children;
    $[14] = expandedPanelId;
    $[15] = shouldOpenEntry;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <Root>{t10}{t11}</Root>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}
function _temp(faqItem) {
  return {
    "@type": "Question",
    name: faqItem.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faqItem.answer
    }
  };
}
export default Faq;